import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { CommunicationService } from '../../services/communication/communication.service';
import { HelperService } from '../../util/helper/helper.service';
/**
  * This component is used to move the cards from one queue to another queue.
  * 
  * User can move a single card or all the cards from a particular queue
*/
@Component({
  selector: 'app-move-patient-popup',
  templateUrl: './move-patient-popup.component.html',
  styleUrls: ['./move-patient-popup.component.scss']
})
export class MovePatientPopupComponent implements OnInit {
  movePatientForm: FormGroup;
  allQueues = [];
  allBoards = [];
  dashboardId;
  showLoader = false;
  queueListener;

  constructor(
    public dialogRef: MatDialogRef<MovePatientPopupComponent>,
    private FB: FormBuilder,
    private helper: HelperService,
    private afs: AngularFirestore,
    private communicationService: CommunicationService,
    @Inject(MAT_DIALOG_DATA) public popup) {
      this.communicationService.getBoards.subscribe(boards=>{
        this.allBoards = boards;
      })
    }

  ngOnInit() {
    this.generateQueueForm();
    if(this.popup.queueId)
      this.getAllQueues();
  }

  generateQueueForm(){
    this.dashboardId = this.popup.selectedBoard&&this.popup.selectedBoard.id;
    this.movePatientForm = this.FB.group({
      dashboardId: [ this.dashboardId || '', [Validators.required]],
      queueId: ['', [Validators.required]]
    })
  }

  /**
    * Get the list of queues from firebase to show in the dropdown
  */
  getAllQueues(){
    const id = this.movePatientForm.value.dashboardId;
    this.showLoader = true;
    this.movePatientForm.patchValue({queueId: null});
    if(this.queueListener)  
      this.queueListener.unsubscribe();
    this.queueListener = this.afs.collection("Queue", ref => ref.where("status", '==', 'Active').where("board.reference", '==', `QueueBoard/${id}`)).valueChanges().subscribe((queues: any) => {
      queues = this.helper.orderQueue(queues);
      if(this.popup.queueId)
        this.allQueues = queues.filter(x=> x.id !== this.popup.queueId && !x.disabled);
      else
        this.allQueues = queues;
      this.showLoader = false;
    })
  }

  /**
    * Call the API to move the cards
  */
  onSubmit(){
    if(this.movePatientForm.valid){
      const data = {
        queueId: this.movePatientForm.value.queueId,
        moveLabel: this.dashboardId === this.movePatientForm.value.dashboardId
      }
      this.dialogRef.close({data: data});
    }
  }

  ngOnDestroy(): void {
    if(this.queueListener)  
      this.queueListener.unsubscribe();
  }

}
